module.exports = __webpack_public_path__ + "static/media/verhaltensbasiert_step_3.ca906af2.png";